import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "play", "pause"];
  static values = { timeLimit: String, currentSectionTimerKey: String };

  initialize() {
    this.timer = null;
    this.startTime = 0;
    
    const elapsed = this.getElapsedFromCookie();
    if (elapsed) {
      this.currentTime = parseInt(elapsed); // Parse the value as an integer
    } else {
      this.currentTime = 0; // Set the default value to 0
    }
    this.updateDisplay();
    this.startTimer();
  }

  parseTime(timeString) {
    const [minutes, seconds] = timeString.split(":");
    return parseInt(minutes) * 60 + parseInt(seconds);
  }

  startTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => {
      this.currentTime++;

      if (this.currentTime <= 0) {
        clearInterval(this.timer);
      }

      this.updateDisplay();
      this.setElapsedToCookie();
    }, 1000);

    this.togglePlayPause(true);
  }

  stopTimer() {
    clearInterval(this.timer);
    this.timer = null;

    this.togglePlayPause(false);
    this.setElapsedToCookie();
  }

  updateDisplay() {
    const minutes = Math.floor(this.currentTime / 60);
    const seconds = this.currentTime % 60;

    this.displayTarget.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`;

    if (this.currentTime > this.parseTime(this.timeLimitValue)) {
      this.displayTarget.classList.add("animate-pulse");
    }
  }

  togglePlayPause(isPlaying) {
    if (isPlaying) {
      this.playTarget.style.display = "none";
      this.pauseTarget.style.display = "block";
    } else {
      this.playTarget.style.display = "block";
      this.pauseTarget.style.display = "none";
    }
  }

  toggle() {
    if (this.timer) {
      this.stopTimer();
    } else {
      this.startTimer();
    }
  }

  setElapsedToCookie() {
    document.cookie = `${this.currentSectionTimerKeyValue}=${this.currentTime}; path=/`;
  }

  getElapsedFromCookie() {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === this.currentSectionTimerKeyValue) {
        return value;
        // if (value === undefined) {
        //   return 0;
        // } else {
        //   return value;
        // }
      }
    }
    return null;
  }
}
